import * as React from 'react';
import { motion } from "framer-motion";

const AuthLayout = ({ children, title }) => (
  <div className="min-h-screen bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 flex items-center justify-center p-4">
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="w-full max-w-md bg-white shadow-2xl rounded-2xl border border-gray-200 p-8"
    >
      <div className="mb-6 text-center">
        <img
          src="/GearLAB_logo.png"
          alt="GearLAB Digital"
          className="mx-auto w-40"
        />
      </div>
      <h2 className="text-3xl font-extrabold text-center text-gray-800 mb-4">
        {title}
      </h2>
      <p className="text-gray-600 text-sm text-center mb-8">
        {title === "Login"
          ? "Access your account to continue."
          : "Create a new account to get started!"}
      </p>
      {children}
    </motion.div>
  </div>
);

export default AuthLayout;
